import React from "react";
import aboutimg from "../Assessts/About.jpg";
export default function AboutPage() {
  return (
    <div>
      {/* Hero Section */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "400px",
          overflow: "hidden",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <img
          src={aboutimg}
          alt="About Us"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "brightness(60%)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "48px", fontWeight: "bold" }}>About Us</h1>
          <p>
            <span style={{ color: "#fff" }}>Home</span>{" "}
            <span style={{ color: "skyblue" }}>/ About Us</span>
          </p>
        </div>
      </div>

      {/* Content Section */}
      <div
        style={{
          padding: "50px 20px",
          maxWidth: "1000px",
          margin: "0 auto",
          lineHeight: "1.6",
        }}
      >
        {/* Company Overview */}
        <h2
          style={{
            textAlign: "center",
            color: "#074f86ff",
            fontSize: "2rem",
            fontWeight: "600",
          }}
        >
          About <b>Technocrat Aerospace & Defence Pvt. Ltd.</b>
        </h2>
        <p>
          <b>Technocrat Aerospace and Defence Pvt. Ltd.</b> positions itself as a
          technology integrator and service provider facilitating advanced{" "}
          <b>aerospace</b> and <b>defense industries</b> through a combination of
          innovative products and tailored services.
        </p>
        <p>
          The company offers mission-critical products spanning{" "}
          <b>Data Acquisition (DAQ) systems</b>, <b>RF/Microwave modules</b>,{" "}
          <b>Rugged Embedded Computing</b>, <b>Avionics Interfaces</b>,{" "}
          <b>Sensors</b>, <b>Cable Harnesses</b>, and <b>Custom Cockpit Controls</b>,
          alongside build-to-print manufacturing and system integration services
          for <b>Aerospace</b>, <b>Railways</b>, and <b>Defence</b> applications.
        </p>


             <p>
          <b>TAAD</b> is an <b>ISO 9001:2015</b> and <b>CE-certified</b> manufacturer,
          system integrator, and service provider delivering{" "}
          <b>high-performance solutions</b> for <b>Aerospace</b>,{" "}
          <b>Defence</b>, <b>Railways</b>, and <b>Scientific Research</b>.
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li>End-to-end <b>Design</b>, <b>Engineering</b>, and <b>Qualification</b>.</li>
          <li>
            Rapid customization for <b>Mission-Critical</b> applications.
          </li>
          <li>
            Proven <b>Integration Capabilities</b> across avionics, power, and test
            systems.
          </li>
        </ul>

        {/* Focus Areas */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Core Focus Areas</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            Indigenous innovation in <b>Avionics</b>, <b>Sensors</b>, and{" "}
            <b>Rugged Embedded Systems</b> for defense applications.
          </li>
          <li>
            Leveraging <b>Artificial Intelligence (AI)</b> for autonomous systems,
            predictive maintenance, and cyber defense.
          </li>
          <li>
            Integrating <b>Augmented Reality (AR)</b> and <b>Virtual Reality (VR)</b>{" "}
            for training, simulation, and mission readiness.
          </li>
          <li>
            Advancing <b>Satellite Miniaturization</b> and <b>Next-Gen Communications</b>{" "}
            for defense intelligence.
          </li>
          <li>
            Promoting sustainability through <b>Green Manufacturing</b> and{" "}
            <b>Lightweight Aerospace Components</b>.
          </li>
          <li>
            Exploring <b>Robotics</b>, <b>Autonomous Platforms</b>, and{" "}
            <b>Hypersonic Weapons</b> for modernization.
          </li>
          <li>
            Prioritizing <b>Cybersecurity</b> to protect critical infrastructure.
          </li>
        </ul>

        {/* Emerging Technologies */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Emerging Technologies</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            <b>AI & ML</b> for predictive maintenance and flight automation.
          </li>
          <li>
            <b>Advanced Avionics</b> and <b>Embedded Systems</b> for rugged aerospace use.
          </li>
          <li>
            <b>3D Printing</b> for rapid prototyping and lightweight components.
          </li>
          <li>
            <b>Hypersonic Technologies</b> for next-generation propulsion systems.
          </li>
          <li>
            <b>Miniaturized Satellite Systems</b> and <b>Secure Space Communications</b>.
          </li>
          <li>
            <b>AR & VR</b> for pilot training and mission simulation.
          </li>
          <li>
            <b>Advanced Materials</b> to improve strength and fuel efficiency.
          </li>
          <li>
            <b>Cybersecurity Frameworks</b> for aerospace network protection.
          </li>
        </ul>

        {/* Product & Services */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Products & Services</h2>
        <p>
          <b>Technocrat Aerospace and Defence Pvt. Ltd.</b> provides a wide range
          of cutting-edge solutions such as <b>Avionics Systems</b>,{" "}
          <b>High-Precision Sensors</b>, <b>Switching Systems</b>,{" "}
          <b>Power Backup Solutions</b>, and <b>Custom Harness Assemblies</b>.
        </p>
        <p>
          The company also specializes in <b>System Integration</b>,{" "}
          <b>Prototype Development</b>, and <b>Build-to-Spec Manufacturing</b> for
          national defense and aerospace clients, with global collaborations and
          partnerships enhancing innovation.
        </p>

        {/* Sensor Customization */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Sensor Customization Capabilities</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li>Custom sensor design for specialized aerospace requirements.</li>
          <li>Performance optimization under extreme environmental conditions.</li>
          <li>
            <b>Analog/Digital Signal Conditioning</b> and <b>Calibration</b>.
          </li>
          <li>
            <b>Connector</b> and <b>Housing Customization</b> (MIL-spec, Titanium, etc.).
          </li>
          <li>
            <b>Multi-sensor Integration</b> for compact assemblies.
          </li>
          <li>
            Full compliance with <b>MIL-Spec</b>, <b>AS9100</b>, and certification standards.
          </li>
        </ul>

        {/* Made in India Section */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Proudly Made in India</h2>
        <p>
          <b>Technocrat Aerospace & Defence (TAAD)</b> proudly aligns with the{" "}
          <b>Atmanirbhar Bharat</b> initiative, driving indigenous innovation and
          manufacturing advanced aerospace and defense technologies in India.
        </p>
        <p>
          TAAD’s indigenous portfolio includes <b>DAQ Systems</b>,{" "}
          <b>RF Modules</b>, <b>Rugged Embedded Computers</b>,{" "}
          <b>Avionics Interfaces</b>, <b>Sensors</b>, and <b>PCB Assemblies</b> —
          all developed to meet <b>global standards</b> with local expertise.
        </p>

        {/* Company Profile */}

   

        {/* Core Product Lines */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Core Product Lines</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li><b>Advanced Avionics</b> & <b>Rugged Embedded Compute</b></li>
          <li><b>Tethered Drone Systems</b> for ISR and surveillance</li>
          <li><b>Sensor Assemblies</b>: Proximity, Hydrostatic, Environmental</li>
          <li><b>Vision Systems</b>: EO/IR Gimbals and Surveillance Solutions</li>
          <li><b>Switching & Controls</b>: Firing Boxes, Grips, Cockpit Units</li>
          <li><b>RF/Radar Subsystems</b>: Antenna & Interconnect Modules</li>
          <li><b>Turnkey Test Benches</b> and Simulation Systems</li>
          <li><b>Aerospace Grade Cable Harness</b> and Looms</li>
          <li><b>Laser Inspection</b> and Tracking Systems</li>
        </ul>

        {/* Quality & Compliance */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Quality & Certification</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li><b>ISO 9001:2015 QMS</b> and <b>CE Compliance</b> across all products.</li>
          <li>
            Adherence to <b>Aerospace-Grade Documentation</b> and <b>Traceability</b>.
          </li>
          <li>Meets <b>EMI/EMC</b>, <b>Environmental</b>, and <b>Safety Standards</b>.</li>
        </ul>

        {/* Recognition */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Recognition & Ecosystem</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li>Recognized by <b>BHEL</b>, <b>HAL</b>, <b>ISRO</b>, and <b>RDSO</b>.</li>
          <li>Active participation in <b>Defense</b> and <b>Railway Technology</b> exhibitions.</li>
        </ul>

        {/* Leadership */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Leadership</h2>
        <p>
          The company is led by <b>Mr. Vijay Raj Tiwari</b>, <b>Managing Director</b>{" "}
          and <b>CEO</b>, who drives innovation and operational excellence across
          aerospace and defense domains.
        </p>

        {/* Why TAAD */}
        <h2 style={{ color: "#074f86ff", marginTop: "40px" }}>Why Choose TAAD</h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li>Faster qualification through <b>Accurate Simulation</b>.</li>
          <li><b>Rugged & Reliable</b> designs for mission-critical use.</li>
          <li><b>Custom Engineering</b> and <b>System Integration Expertise</b>.</li>
          <li><b>Lifecycle Support</b> with rapid turnaround.</li>
          <li><b>Certified Manufacturing</b> meeting <b>Global Standards</b>.</li>
        </ul>
      </div>
    </div>
  );
}
